import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'popup-message',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './popup-message.component.html',
  styleUrl: './popup-message.component.css'
})

export class PopupMessageComponent {
  @Input() type: string | null = null;
  @Input() message: string | null = null;
  @Output() close = new EventEmitter<void>()
  closeMessage() {
    this.close.emit();
  }
}
